import {
  GET_HEALTHDAY_DETAIL,
  GET_HEALTHDAY_DETAIL_SUCCESS,
  GET_HEALTHDAY_DETAIL_FAIL,
  GET_HEALTHDAYS,
  GET_HEALTHDAYS_SUCCESS,
  GET_HEALTHDAYS_FAIL,
  ADD_HEALTHDAY,
  ADD_HEALTHDAY_SUCCESS,
  ADD_HEALTHDAY_FAIL,
  UPDATE_HEALTHDAY,
  UPDATE_HEALTHDAY_SUCCESS,
  UPDATE_HEALTHDAY_FAIL,
  ADD_HEALTHDAY_FILEUPLOAD,
  ADD_HEALTHDAY_FILEUPLOAD_SUCCESS,
  ADD_HEALTHDAY_FILEUPLOAD_FAIL,
  ADD_HEALTHDAY_DATAUPLOAD,
  ADD_HEALTHDAY_DATAUPLOAD_SUCCESS,
  ADD_HEALTHDAY_DATAUPLOAD_FAIL,
  GET_CENTRES,
  GET_CENTRES_SUCCESS,
  GET_CENTRES_FAIL,
  GET_CENTRE_TYPES,
  GET_CENTRE_TYPES_SUCCESS,
  GET_CENTRE_TYPES_FAIL,
  ADD_CENTRE,
  ADD_CENTRE_SUCCESS,
  ADD_CENTRE_FAIL,
  UPDATE_CENTRE,
  UPDATE_CENTRE_SUCCESS,
  UPDATE_CENTRE_FAIL,
  GET_CENTRE_DETAIL,
  GET_CENTRE_DETAIL_SUCCESS,
  GET_CENTRE_DETAIL_FAIL,
  GET_ETHNICITIES,
  GET_ETHNICITIES_SUCCESS,
  GET_ETHNICITIES_FAIL,
  GET_NDBNETWORKTYPES,
  GET_NDBNETWORKTYPES_SUCCESS,
  GET_NDBNETWORKTYPES_FAIL,
  GET_PHONECONTRACTS,
  GET_PHONECONTRACTS_SUCCESS,
  GET_PHONECONTRACTS_FAIL,
} from "./actionTypes"

export const getHealthdays = () => ({
  type: GET_HEALTHDAYS,
})

export const getHealthdaysSuccess = healthdays => ({
  type: GET_HEALTHDAYS_SUCCESS,
  payload: healthdays,
})

export const getHealthdaysFail = error => ({
  type: GET_HEALTHDAYS_FAIL,
  payload: error,
})

export const getHealthdayDetail = rowID => ({
  type: GET_HEALTHDAY_DETAIL,
  rowID,
})

export const getHealthdayDetailSuccess = details => ({
  type: GET_HEALTHDAY_DETAIL_SUCCESS,
  payload: details,
})

export const getHealthdayDetailFail = error => ({
  type: GET_HEALTHDAY_DETAIL_FAIL,
  payload: error,
})

export const addHealthday = healthday => ({
  type: ADD_HEALTHDAY,
  payload: healthday,
})

export const addHealthdaySuccess = healthday => ({
  type: ADD_HEALTHDAY_SUCCESS,
  payload: healthday,
})

export const addHealthdayFail = error => ({
  type: ADD_HEALTHDAY_FAIL,
  payload: error,
})

export const updateHealthday = healthday => ({
  type: UPDATE_HEALTHDAY,
  payload: healthday,
})

export const updateHealthdaySuccess = healthday => ({
  type: UPDATE_HEALTHDAY_SUCCESS,
  payload: healthday,
})

export const updateHealthdayFail = error => ({
  type: UPDATE_HEALTHDAY_FAIL,
  payload: error,
})

export const getCentres = (active = false) => ({
  type: GET_CENTRES,
  payload: active,
})

export const getCentresSuccess = centres => ({
  type: GET_CENTRES_SUCCESS,
  payload: centres,
})

export const getCentresFail = error => ({
  type: GET_CENTRES_FAIL,
  payload: error,
})

export const getCentreTypes = () => ({
  type: GET_CENTRE_TYPES,
})

export const getCentreTypesSuccess = centreTypes => ({
  type: GET_CENTRE_TYPES_SUCCESS,
  payload: centreTypes,
})

export const getCentreTypesFail = error => ({
  type: GET_CENTRE_TYPES_FAIL,
  payload: error,
})

export const getCentreDetail = rowID => ({
  type: GET_CENTRE_DETAIL,
  rowID,
})

export const getCentreDetailSuccess = details => ({
  type: GET_CENTRE_DETAIL_SUCCESS,
  payload: details,
})

export const getCentreDetailFail = error => ({
  type: GET_CENTRE_DETAIL_FAIL,
  payload: error,
})

export const addCentre = centre => ({
  type: ADD_CENTRE,
  payload: centre,
})

export const addCentreSuccess = centre => ({
  type: ADD_CENTRE_SUCCESS,
  payload: centre,
})

export const addCentreFail = error => ({
  type: ADD_CENTRE_FAIL,
  payload: error,
})

export const updateCentre = centre => ({
  type: UPDATE_CENTRE,
  payload: centre,
})

export const updateCentreSuccess = centre => ({
  type: UPDATE_CENTRE_SUCCESS,
  payload: centre,
})

export const updateCentreFail = error => ({
  type: UPDATE_CENTRE_FAIL,
  payload: error,
})

export const getEthnicities = () => ({
  type: GET_ETHNICITIES,
})

export const getEthnicitiesSuccess = ethnicities => ({
  type: GET_ETHNICITIES_SUCCESS,
  payload: ethnicities,
})

export const getEthnicitiesFail = error => ({
  type: GET_ETHNICITIES_FAIL,
  payload: error,
})

export const getPhoneContracts = () => ({
  type: GET_PHONECONTRACTS,
})

export const getPhoneContractsSuccess = phoneContracts => ({
  type: GET_PHONECONTRACTS_SUCCESS,
  payload: phoneContracts,
})

export const getPhoneContractsFail = error => ({
  type: GET_PHONECONTRACTS_FAIL,
  payload: error,
})

export const getNDBNetworkTypes = () => ({
  type: GET_NDBNETWORKTYPES,
})

export const getNDBNetworkTypesSuccess = NDBNetworkTypes => ({
  type: GET_NDBNETWORKTYPES_SUCCESS,
  payload: NDBNetworkTypes,
})

export const getNDBNetworkTypesFail = error => ({
  type: GET_NDBNETWORKTYPES_FAIL,
  payload: error,
})

export const addHealthdayFileUpload = file => ({
  type: ADD_HEALTHDAY_FILEUPLOAD,
  payload: file,
})

export const addHealthdayFileUploadSuccess = result => ({
  type: ADD_HEALTHDAY_FILEUPLOAD_SUCCESS,
  payload: result,
})

export const addHealthdayFileUploadFail = error => ({
  type: ADD_HEALTHDAY_FILEUPLOAD_FAIL,
  payload: error,
})
export const addHealthdayDataUpload = () => ({
  type: ADD_HEALTHDAY_DATAUPLOAD,
})

export const addHealthdayDataUploadSuccess = data => ({
  type: ADD_HEALTHDAY_DATAUPLOAD_SUCCESS,
  payload: data,
})

export const addHealthdayDataUploadFail = error => ({
  type: ADD_HEALTHDAY_DATAUPLOAD_FAIL,
  payload: error,
})
